import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast'
import { RealEstateDataFooterData, RealEstateDataPage } from 'types'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'

interface ExternalProps {
  pages: RealEstateDataPage[]
  development_id: string
  property_id: string
  novelty_id: string
}

type CombinedProps = RealEstateDataFooterData & ExternalProps

const Footer10 = (props: CombinedProps) => {
  const [isMounted, setIsMounted] = useState(false)

  const { global_data, showHeader, backgroundColor, titles, phones, opening_hours } = props

  const branch_office = global_data.branches

  const Header = require(`@components/header/2`)?.default

  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const social = global_data.pageConfig.social
  const captcha = global_data.pageConfig.keys.captcha
  const realEstateName = global_data.name
  const email = global_data.contact_data.email

  const getCurrentYear = () => new Date().getFullYear()

  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    email: '',
  })

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    const tags = ['Sitio Web', 'Newsletter', realEstateName]
    sendContactFormMediacore({
      data: { ...data, tags, token: token },
      type: 'newsletter',
      site: global_data.id,
    })
    ;(document.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    return toast.success('Te suscribiste a nuestro newsletter correctamente.')
  }

  const handleInputChange = (e: { target: { name: string; value: string } }) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    setIsMounted(true)
  }, [])
  return (
    isMounted && (
      <footer
        id="footer"
        className="footer-10"
      >
        {showHeader && <Header {...props} />}
        <Row
          style={{ backgroundColor: backgroundColor }}
          className="content text-lg-start text-center justify-content-center"
        >
          <Col
            xs={12}
            md={4}
            className="ps-lg-5"
          >
            {' '}
            <ElementHTML
              children={titles?.opening_hours}
              elementType="h4"
              className="mb-3 title"
            />
            {opening_hours && opening_hours?.length > 0 ? (
              opening_hours.map((branch) => (
                <ElementHTML
                  children={branch}
                  elementType="p"
                />
              ))
            ) : (
              <></>
            )}
            <ElementHTML
              children={titles?.global}
              elementType="h4"
              className="title mt-5"
            />
            <a
              href={`mailto:${email}`}
              style={{ color: 'var(--secondaryColor)' }}
            >
              {email}{' '}
            </a>
          </Col>
          <Col
            xs={12}
            md={4}
            className="ps-lg-5"
          >
            <ElementHTML
              children={titles?.branch_office}
              elementType="h4"
              className="mb-3 title mt-5 mt-lg-0"
            />
            {branch_office.length > 0 ? (
              branch_office.map((branch) => (
                <div className="pb-3">
                  <ElementHTML
                    children={branch?.address}
                    elementType="p"
                    className="mt-3"
                  />
                  <ElementHTML
                    children={
                      branch?.city && branch?.province
                        ? `${branch.city} - ${branch.province}`
                        : branch?.city || branch?.province || ''
                    }
                    elementType="p"
                  />
                  {branch?.contact_data?.phonesLine.map((phone, index) => (
                    <ElementHTML
                      key={index}
                      children={`Tel. ${phone.replace('54911', '54 9 11 ')}`}
                      elementType="p"
                    />
                  ))}
                </div>
              ))
            ) : (
              <></>
            )}
          </Col>
          <Col
            xs={12}
            md={4}
            className="ps-lg-5"
          >
            <ElementHTML
              children={titles?.social}
              elementType="h4"
              className="mb-3 title  mt-5 mt-lg-0"
            />
            {social?.instagram && (
              <a
                target="_blank"
                aria-label="Lea más en la red social? instagram"
                href={social?.instagram}
                className={social?.instagram ? 'd-inline' : 'd-none'}
              >
                <i className={`icon icon-instagram${iconsStyle}`}></i>
              </a>
            )}
            {social?.facebook && (
              <a
                target="_blank"
                aria-label="Lea más en la red social? facebook"
                href={social?.facebook}
                className={social?.facebook ? 'd-inline' : 'd-none'}
              >
                <i className={`icon icon-facebook${iconsStyle} social-icon`}></i>
              </a>
            )}
            {social?.linkedin && (
              <a
                target="_blank"
                aria-label="Lea más en la red social? linkedin"
                href={social?.linkedin}
                className={social?.linkedin ? 'd-inline' : 'd-none'}
              >
                <i className={`icon icon-linkedin${iconsStyle}`}></i>
              </a>
            )}
            {social?.youtube && (
              <a
                target="_blank"
                aria-label="Lea más en la red social? youtube"
                href={social?.youtube}
                className={social?.youtube ? 'd-inline' : 'd-none'}
              >
                <i className={`icon icon-youtube${iconsStyle}`}></i>
              </a>
            )}
            {social?.twitter && (
              <a
                target="_blank"
                aria-label="Lea más en la red social? twitter"
                href={social?.twitter}
                className={social?.twitter ? 'd-inline' : 'd-none'}
              >
                <i className={`icon icon-twitter${iconsStyle}`}></i>
              </a>
            )}
            {social?.tiktok && (
              <a
                target="_blank"
                aria-label="Lea mas en la red social tiktok"
                href={social?.tiktok}
                className={social?.tiktok ? 'd-inline' : 'd-none'}
              >
                <i className={`icon-tiktok${iconsStyle}`}></i>
              </a>
            )}
            <ElementHTML
              children={titles?.phones}
              elementType="h4"
              className="mb-3 title mt-5 "
            />
            {phones?.map((phone, index) => (
              <div
                key={index}
                className="phone-row"
              >
                <ElementHTML
                  children={phone.branch}
                  elementType="p"
                  className="branch"
                />
                <ElementHTML
                  children={phone.phone}
                  elementType="p"
                  className="phone"
                />
              </div>
            ))}

            <ElementHTML
              children={titles?.newsletter}
              elementType="h4"
              className="mb-3 mt-5 title"
            />
            <form
              onSubmit={sendForm}
              id="formNewsletter"
            >
              <div className="d-flex mb-lg-3">
                <input
                  type="email"
                  onChange={handleInputChange}
                  name="email"
                  required
                  placeholder="Ingresá tu mail"
                  className={`mr-2`}
                />
                <button
                  disabled={disabled}
                  type="submit"
                  className={'icon-arrow'}
                  aria-label="Boton enviar formulario"
                ></button>
              </div>
              {captcha ? (
                <ReCAPTCHA
                  sitekey={captcha}
                  onChange={(value) => {
                    setDisabled(false)
                    onChange(value)
                  }}
                />
              ) : (
                ''
              )}
            </form>
          </Col>
          <Col
            xs={12}
            className="text-center justify-content-center d-lg-flex align-items-start mt-5 mt-lg-0"
          >
            <p className="copy">
              Promoted by{' '}
              <a
                target="_blank"
                style={{ color: '#00A1FF' }}
                className="normal-color"
                href="https://mediahaus.com.ar"
              >
                {' '}
                MediaHaus
              </a>{' '}
              - Powered by{' '}
              <a
                target="_blank"
                href="https://mediacore.app/"
                style={{ color: '#FFF' }}
              >
                {' '}
                MediaCore
              </a>
              <br />
              <span className="small-text white">
                Todos los derechos reservados ® {getCurrentYear()}
              </span>
            </p>
          </Col>
        </Row>
      </footer>
    )
  )
}

export default Footer10
